import { useTranslation } from "react-i18next";
import renderItem from "./renderItem";

const fields = ["amount", "payCode", "payment", "status"];

const MealAllowanceRule = ({ data }) => {
    const { t } = useTranslation();

    return (
        <div className="tooltip-content-style">
            <h3 className="font-weight-bolder text-left mb-1">{t("meal-allowance-rule")}</h3>
            {fields.map((item, i) => {
                return data?.[item] && <div key={i}>{data?.[item] && renderItem(data[item], item, t)}</div>;
            })}
        </div>
    );
};

export default MealAllowanceRule;
